import {createTheme, MantineColorsTuple} from "@mantine/core";

const zmrzlinaRed: MantineColorsTuple = [
	'#feecec',
	'#f7d4d4',
	'#f3a4a4',
	'#f07272',
	'#ee4947',
	'#ed322c',
	'#ed261f',
	'#d31c14',
	'#bd1610',
	'#a5090b'
];

const zmrzlinaYellow: MantineColorsTuple = [
	"#fff9e2",
	"#fff0cd",
	"#fee09d",
	"#fdd068",
	"#fcc13c",
	"#fcb821",
	"#fcb311",
	"#e09d02",
	"#c88b00",
	"#ad7700"
]


export const theme = createTheme({
	primaryColor: 'zmrzlina-yellow',
	primaryShade: 6,
	autoContrast: true,
	fontFamily: "Libre Franklin",
	focusRing: 'never',
	respectReducedMotion: true,
	headings: {
		fontFamily: "PT Serif"
	},
	colors: {
		'zmrzlina-red': zmrzlinaRed,
		'zmrzlina-yellow': zmrzlinaYellow
	}
})